export default __webpack_public_path__ + "static/media/cat_glasseson.5b38ac00.jpg";